// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"BreadCrumbs-styles-module--bread-crumbs--3Yxpn","logo":"BreadCrumbs-styles-module--logo--3uMgD responsive-module--hidden-sm--3J4xQ"};